import React, { useSyncExternalStore } from 'react';
import PropTypes from 'prop-types';
import { isMuted, setMuted, subscribeSound, unlockAudio } from '../../utils/sounds';
import './sound-toggle.scss';

const NO_FILL = { fill: 'none' };

const SoundIcon = ({ muted }) => (
  <svg className="nb-sound-toggle__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3.5 9.5v5h3.2l4.8 4v-13l-4.8 4H3.5z" style={NO_FILL} />
    {muted ? (
      <path d="M15.5 9.5l5 5M20.5 9.5l-5 5" style={NO_FILL} />
    ) : (
      <>
        <path d="M15 9.2a4 4 0 0 1 0 5.6" style={NO_FILL} />
        <path d="M17.8 6.6a7.6 7.6 0 0 1 0 10.8" style={NO_FILL} />
      </>
    )}
  </svg>
);

SoundIcon.propTypes = { muted: PropTypes.bool.isRequired };

export const useSoundMuted = () => useSyncExternalStore(subscribeSound, isMuted);

const SoundToggle = () => {
  const muted = useSoundMuted();

  const toggle = () => {
    setMuted(!muted);
    if (muted) unlockAudio();
  };

  return (
    <button
      type="button"
      className={`nb-sound-toggle${muted ? ' is-off' : ''}`}
      aria-pressed={muted}
      aria-label={muted ? 'Увімкнути звук' : 'Вимкнути звук'}
      title={muted ? 'Увімкнути звук' : 'Вимкнути звук'}
      onClick={toggle}
    >
      <SoundIcon muted={muted} />
    </button>
  );
};

export default SoundToggle;
